module.exports = __webpack_public_path__ + "img/drafticon.d9468f99.svg";